<template>
  <v-layout row justify-center>
    <!-- 회의실 -->
    <v-dialog v-model="dialog" persistent 
      :max-width="selectedType==='room' ? '1000px' : '1200px'" 
      max-height="1150px">
      <v-card>
        <v-card-title style="padding-top: 15px; padding-bottom:0px;">
          <div style="width: 5px; height: 20px; background: #464775; float:left; margin-top: 10px; margin-left:10px; margin-right: 10px;"></div>
          <div class="page-header-left" style="margin-bottom:-10px;">
            <!-- <img v-bind:src="computePageHeaderIcon" style="margin-bottom:-8px;" alt="title bar"> -->
            <h3 class="pr-3" style="font-weight: 600;" >{{ $t('page.meeting-control.invitation') }}</h3>
          </div>  
          <!-- <span class="headline">{{ $t('page.meeting-reserve.meeting-room') }}</span> -->
        </v-card-title>
        <div class="divider-bar" style="margin-top: 15px; margin-bottom:5px; background: #D8D8D8;"></div>
        <v-card-text :style=" (selectedType==='room' ? 'height: 550px;' : 'height: 580px;') + ' !important; padding: 4px;'">
          <v-container grid-list-xl fluid style="padding-top: 5px; padding-bottom: 5px;">
            <v-layout row wrap style="padding: 5px;">
              <v-flex md4 xs9 v-if="meetingInfo.type !== 0" style="margin-top: 0px; padding-bottom: 3px; padding-left: 0;"> <!-- 개인 단말 고르는거 삭제 -->
                <div class="meeting-additional-top-btn" @click="selectedTypeChanged('room')" 
                  :class="selectedType==='room' ? 'btn-active' : ''">
                  {{ $t('page.meeting-reserve.meeting-room') }}
                </div>
                <div class="meeting-additional-top-btn" @click="selectedTypeChanged('personal')"
                  :class="selectedType==='personal' ? 'btn-active' : ''">
                  {{ $t('page.meeting-reserve.attendee') }}
                </div>
                <!-- <v-btn class="btn-round" outline flat @click="selectedTypeChanged('room')"
                  :color="selectedType==='room' ? 'primary' : 'grey'">
                  {{ $t('page.meeting-reserve.meeting-room') }}
                </v-btn>
                <v-btn class="btn-round" outline flat @click="selectedTypeChanged('personal') /* selectedType='personal' */"
                  :color="selectedType==='personal' ? 'primary' : 'grey'">
                  {{ $t('page.meeting-reserve.attendee') }}
                </v-btn> -->
              </v-flex>
              <v-spacer/>
              <!-- <v-flex md3 xs3 v-if="selectedType==='personal'">
                <v-sheet class="pa-1 primary lighten-1" style="margin-top: -25px; padding-bottom: 3px; height:45px; max-width: 343px;" >
                  <v-text-field
                    append-icon="search"
                    v-model="search"
                    :label="$t('page.meeting-reserve.organization.search')"
                    dark
                    flat
                    solo-inverted
                    hide-details
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>    
                </v-sheet>
              </v-flex> -->
            </v-layout>
            <v-layout v-show="selectedType === 'room'">
              <v-flex lg4 md4 sm12 xs12>
                <v-layout>
                  <v-flex xs12 md12 style="padding-left: 0px; padding-right: 0px; padding-bottom:0;">
                    <div class="searchbox">
                      <div class="search_top inblk">
                          <input type="text" v-model="searchRoomData" class="search_input" :placeholder="$t('page.meeting-reserve.meeting-room-popup.room-search')" v-on:keyup="searchEnterKey" style="top: -1px; height: 38px; padding-left:9px;">
                          <button class="search_btn" @click="searchRooms(searchRoomData)">
                              <span class="ir">{{ $t('page.meeting-reserve.search') }}</span>
                          </button>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-spacer/>
            </v-layout>
            <v-layout style="height: 400px;" v-show="selectedType === 'room'">
              <!-- 회의실 Tree -->
              <v-flex lg4 md4 sm12 xs12>
                <v-card class="mx-auto">
                  <div>
                    <v-layout style="height: 406px; width: calc(100%);">
                      <v-flex style="overflow: auto; max-height: 370px; position: relative; top: 20px; ">
                        <v-card-text style="padding:5px; padding-top: 0px !important;" >
                          <v-treeview
                            v-model="roomTree"
                            :active.sync="roomActive"
                            :items="filteredRoomItems"
                            :filter="filter"
                            item-key="_id"
                            :item-text="''"
                            :selectable="false"
                            :activatable="true"
                            active-class="primary--text"
                            open-on-click
                            :open.sync="roomOpen"
                            :open-all="openAll"
                            transition
                            return-object
                            :multiple-active="meetingInfo.type === 0 ? false : true"
                            @update:active="selectedRoomNode"
                          >
                            <template v-slot:prepend="{ item, active }">
                              <div @dblclick="treeViewDoubleClick(item)">
                                <v-icon
                                  style="margin-left: 5px;"
                                  :color="active ? 'primary' : ''"
                                  small
                                  v-text="`${item.type === 'g' ? 'mdi-home-variant' 
                                          : item.type === 'b' ? 'mdi-office-building'
                                          : item.type === 'video' ? 'mdi-desktop-mac' : 'mdi-door-open'}`"
                                  
                                ></v-icon>
                                <span>{{ item.name }}</span>
                              </div>
                            </template>
                          </v-treeview>
                        </v-card-text>
                      </v-flex>
                    </v-layout>
                   </div>
                </v-card>
              </v-flex>
              <!-- 선택된 Room Info -->
              <v-flex lg8 md8 sm12 xs12 v-if="selectedType === 'room'">
                <v-layout>
                  <v-flex lg2 md2 sm6 xs6>
                    <v-layout row wrap justify-center align-center>
                      <div class="add-btn" @click="addItems()" style="margin-top: 160px;">
                        {{ $t('page.meeting-reserve.add') }}
                      </div>
                      <div class="delete-all-btn" @click="deleteAll()">
                        {{ $t('page.meeting-reserve.all-delete') }}
                      </div>
                      <!-- <v-btn class="mx-0" block outline color="success" @click="addItems()" style="margin-top:190px;">
                        {{ $t('page.meeting-reserve.add') }}&nbsp;
                        <v-icon small color="success">mdi-arrow-right-bold</v-icon>
                      </v-btn>
                      <v-btn class="mx-0" block outline color="pink" @click="deleteAll()">
                        {{ $t('page.meeting-reserve.all-delete') }}
                      </v-btn> -->
                    </v-layout>
                  </v-flex>
                  <v-flex lg10 md10 sm12 xs12>
                    <v-card
                      class="mx-auto" style="margin-top:8px;"
                    >
                      <!-- <v-sheet class="pa-1 primary lighten-1" style="height:45px;" >
                        <div class="pa-1 primary lighten-1 subheading" style="color: white;">
                          <v-icon color="white" small style="margin-right: 10px; margin-top: 5px;">people</v-icon>{{ $t('page.meeting-reserve.meeting-room-popup.meeting-room-list') }}
                        </div>
                      </v-sheet> -->
                      <div>
                        <v-layout>
                          <v-flex class="popup-grid-header meeting-additional">
                            <div class="tb-header" style="font-weight: 300; margin-top: 25px; margin-bottom: 10px; margin-left: 10px; ">
                              선택된 회의실
                            </div>
                            <v-data-table v-if="meetingInfo.type !== 0" slot="widget-content"
                              :headers="getMeetingRoomsHeaders()"
                              :items="selectedVideoRoom"
                              :rows-per-page-items="pageItem"
                              class="elevation-0 table-striped"
                              style="overflow: auto; height: 332px;"
                              >
                              <template v-slot:headers="props">
                                <tr style="height:45px !important;">
                                  <th v-for="header in props.headers" :key="header.text"
                                    :class="['header-text-popup', 
                                      'column', 
                                      pagination.descending ? 'desc' : 'asc', 
                                      header.value === pagination.sortBy ? 'active' : '']"
                                  >
                                    <!-- <v-icon small>arrow_upward</v-icon> -->
                                    {{ header.text }}
                                  </th>
                                </tr>
                              </template>
                              <template slot="items" slot-scope="props">
                                <td class="text-xs-center">{{ props.item.name }}</td>
                                <td class="text-xs-center">{{ props.item.deviceInfo.length >= 1 ? props.item.deviceInfo[0].ip : '' }}</td>
                                <td class="text-xs-center">
                                  <div class="room-state-btn" v-if="props.item.deviceInfo.length >= 1">
                                    {{ props.item.deviceInfo[0].status === 'a' 
                                          ? 'Live' 
                                          : props.item.deviceInfo[0].status === 'd'
                                                ? 'Down'
                                                : 'Ping' }}
                                  </div>
                                  <div v-else text-color="white" class="room-state-btn2">
                                    {{ 'Room' }}
                                  </div>
                                  <!-- <v-chip v-if="props.item.deviceInfo.length >= 1" 
                                    label small :color="getStatusColor(props.item.deviceInfo[0].status)" text-color="white" >
                                    {{ props.item.deviceInfo[0].status === 'a' 
                                          ? 'Live' 
                                          : props.item.deviceInfo[0].status === 'd'
                                                ? 'Down'
                                                : 'Ping' }}
                                  </v-chip> -->
                                  <!-- <v-chip v-else
                                    label small :color="'green'" text-color="white" >
                                    {{ 'Room' }}
                                  </v-chip> -->
                                </td>
                                <td class="text-xs-center">
                                  <v-icon color="error" @click="deleteRoomItem(props.item)">clear</v-icon>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Attendee Tree (참여자) -->
            <v-layout v-if="selectedType === 'personal'">
              <v-flex xs3>
                <v-layout>
                  <v-flex xs12 md12 style="padding-left: 0px; padding-right: 0px; padding-bottom:0;">
                    <div class="searchbox">
                      <div class="search_top inblk">
                          <input type="text" v-model="search" class="search_input" :placeholder="$t('page.meeting-reserve.organization.search')" v-on:keyup="searchEnterKey" style="top: -1px; height: 38px; padding-left:9px;">
                          <button class="search_btn" @click="searchUser(search)" >
                              <span class="ir">{{ $t('page.meeting-reserve.search') }}</span>
                          </button>
                      </div>
                    </div>
                    <!-- <v-text-field 
                      :placeholder="$t('page.meeting-reserve.organization.search')" 
                      color="pink" 
                      v-model="search"
                      height="38px"
                      outline
                      hide-details
                      single-line
                      v-on:keyup="searchEnterKey"
                    ></v-text-field> -->
                  </v-flex>
                  <!-- <v-flex xs12 md3 style="padding-left: 0px; padding-top: 2px;">
                    <v-btn class="mx-0 eveluation-0" color="btnColor" dark @click="searchUser(search)" >
                      {{ $t('page.meeting-reserve.search') }}
                    </v-btn>
                  </v-flex>                   -->
                </v-layout>
              </v-flex>
              <v-spacer/>
            </v-layout>
            <v-layout style="height: 400px" v-if="selectedType === 'personal'">
              <v-flex lg3 md3 sm12 xs12>
                <v-card
                  class="mx-auto"
                >
                  <!-- <v-sheet class="pa-1 primary lighten-1" style="height:45px;" >
                    <div class="pa-1 primary lighten-1 subheading" style="color: white;">조직도</div>
                  </v-sheet> -->
                  <div style="overflow: auto; height: 400px;">
                    <v-layout>
                      <v-flex>
                        <v-card-text style="padding:5px;">
                          <v-treeview
                            v-model="attendeeTree"
                            :load-children="fetchUsers"
                            :active.sync="active"
                            :items="organizationItems"
                            :filter="filter"
                            :open.sync="open"
                            item-key="_id"
                            :item-text="$store.state.locale === 'en' 
                              ? 'displayNameEn'
                              : $store.state.locale === 'zn'
                                ? 'displayNameZh'
                                : 'displayName'"
                            active-class="primary--text"
                            open-on-click
                            transition
                            return-object
                            activatable
                          >
                            <template v-slot:prepend="{ item, active }">
                              <v-icon
                                :color="active ? 'primary' : ''"
                                v-text="`mdi-${item.type === 'd' ? 'folder-account' : 'account'}`"
                              ></v-icon>
                            </template>
                            <template v-slot:label="{ item }">
                              <a style="text-decoration: none; color: black !important" @click="selectedNode(item)">{{ item.displayName }}</a>
                            </template>
                          </v-treeview>
                        </v-card-text>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card>
              </v-flex>
              <v-flex lg4 md4 sm12 xs12>
                <v-card class="mx-auto">
                <!-- <v-sheet class="pa-1 primary lighten-1" style="height:45px;" >
                  <div v-if="search === ''" class="pa-1 primary lighten-1 subheading" style="color: white;">
                    {{ selectedTreeNode !== undefined ? `${selectedTreeNode.displayName} (${ $t('page.meeting-reserve.organization.search-result', {count: deptUsers.length}) })` 
                                                      : '' }}
                  </div>
                  <div v-else class="pa-1 primary lighten-1 subheading" style="color: white;">{{ `${$t('page.meeting-reserve.organization.search-word')} : ${search}` }}</div>
                </v-sheet> -->
                  <div>
                    <v-layout>
                      <v-flex class="popup-grid-header meeting-additional">
                        <div class="tb-header" style="font-weight: 300; margin-top: 25px; margin-bottom: 10px; margin-left: 10px; ">
                          검색된 조직 목록
                        </div>
                        <v-data-table
                          v-model="selected"
                          :headers="getPeopleHeaders()"
                          :items="deptUsers"
                          :rows-per-page-items="pageItem"
                          select-all
                          item-key="email"
                          style="height: 350px; overflow-y: auto; margin-bottom: 20px;"
                        >
                          <template v-slot:headers="props">
                            <tr style="height:45px !important;">
                              <th class="header-text-popup">
                                <v-checkbox
                                  :input-value="props.all"
                                  :indeterminate="props.indeterminate"
                                  primary
                                  hide-details
                                  @click.stop="toggleAll"
                                ></v-checkbox>
                              </th>
                              <th v-for="header in props.headers" :key="header.text"
                                :class="['header-text-popup', 
                                  'column', 
                                  pagination.descending ? 'desc' : 'asc', 
                                  header.value === pagination.sortBy ? 'active' : '']"
                                :style="header.width ? header.width : ''"
                                @click="changeSort(header.value)"
                              >
                                <!-- <v-icon small>arrow_upward</v-icon> -->
                                {{ header.text }}
                              </th>
                            </tr>
                          </template>
                          <template v-slot:items="props">
                            <tr :active="props.selected" @click="clickPeople(props)" @dblclick="doubleClick(props)">
                              <td>
                                <v-checkbox
                                  primary
                                  hide-details
                                  :input-value="props.selected"
                                ></v-checkbox>
                              </td>
                              <td class="text-xs-center">
                                {{ $store.state.locale === 'en' 
                                  ? props.item.nameEn 
                                  : $store.state.locale === 'zn'
                                    ? props.item.nameZh
                                    : props.item.name }}
                                <!-- <div class="tooltip">{{ props.item.name }}
                                  <div class="tooltiptext">
                                    <span>{{ props.item.name }}</span>
                                    <span>{{ props.item.department }}</span>
                                    <span>{{ props.item.mobile }}</span>
                                    <span>{{ props.item.email }}</span>
                                  </div>
                                </div> -->
                              </td>
                              <td class="text-xs-center">{{ props.item.empNum }}</td>
                              <!-- <td class="text-xs-center">{{ 
                                $store.state.locale === 'en' 
                                  ? props.item.titleEn
                                  : $store.state.locale === 'zn'
                                    ? props.item.titleZh
                                    : props.item.title
                              }}</td> -->
                              <v-tooltip right v-if="props.item.department !== null">
                                <template v-slot:activator="{ on, attrs }">
                                  <td class="text-xs-center"
                                    v-bind="attrs"
                                    v-on="on"
                                  >{{ 
                                    $store.state.locale === 'en' 
                                      ? props.item.departmentEn 
                                      : $store.state.locale === 'zn'
                                        ? props.item.departmentEn
                                        : props.item.department | textLengthOverCut
                                  }}</td>
                                </template>
                                <span>{{ props.item.department }}</span>
                              </v-tooltip>
                              <td v-else-if="props.item.department === null" class="text-xs-center">
                                  -
                              </td>
                              <!-- <td class="text-xs-center">{{ props.item.title }}</td> -->
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card>
              </v-flex>
              <v-flex lg5 md5 sm12 xs12>
                <v-layout>
                  <v-flex lg2 md2 sm6 xs6>
                    <v-layout row wrap justify-center align-center>
                      <div class="add-btn" @click="setAttendees()" style="margin-top: 160px;">
                        {{ $t('page.meeting-reserve.add') }}
                      </div>
                      <div class="delete-all-btn" @click="deleteAll()">
                        {{ $t('page.meeting-reserve.all-delete') }}
                      </div>
                      <!-- <v-btn class="mx-0" block outline color="success" @click="setAttendees()" style="margin-top:217px;">
                        {{ $t('page.meeting-reserve.add') }}&nbsp;
                        <v-icon small color="success">mdi-arrow-right-bold</v-icon>
                      </v-btn>
                      <v-btn class="mx-0" block outline color="pink" @click="deleteAll()">
                        {{ $t('page.meeting-reserve.all-delete') }}
                      </v-btn> -->
                    </v-layout> 
                  </v-flex>
                  <v-flex lg10 md10 sm12 xs12>
                    <v-card
                      class="mx-auto"
                    >
                      <div>
                        <v-layout>
                          <v-flex class="popup-grid-header meeting-additional">
                            <div class="tb-header" style="font-weight: 300; margin-top: 25px; margin-bottom: 10px; margin-left: 10px; ">
                              선택된 조직 목록
                            </div>
                            <v-data-table
                              :headers="getAttendeeheaders()"
                              :items="selectedAttendees"
                              :rows-per-page-items="pageItem"
                              style="height: 350px; overflow-y: auto; margin-bottom: 20px;"
                              >
                              <template v-slot:headers="props">
                                <tr style="height:45px !important;">
                                  <th v-for="header in props.headers" :key="header.text"
                                    :class="['header-text-popup', 
                                      'column', 
                                      pagination.descending ? 'desc' : 'asc', 
                                      header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)"
                                  >
                                    <!-- <v-icon small>arrow_upward</v-icon> -->
                                    {{ header.text }}
                                  </th>
                                </tr>
                              </template>
                              <template slot="items" slot-scope="props">
                                <td class="text-xs-center">{{ 
                                  $store.state.locale === 'en' 
                                    ? props.item.nameEn ? props.item.nameEn : props.item.username ? props.item.username : props.item.email 
                                    : $store.state.locale === 'zn'
                                      ? props.item.nameZh ? props.item.nameZh : props.item.username ? props.item.username : props.item.email 
                                      : props.item.name ? props.item.name : props.item.username ? props.item.username : props.item.email 
                                }}</td>
                                <td class="text-xs-center">{{ props.item.empNum }}</td>
                                <!-- <td class="text-xs-center">{{ 
                                  $store.state.locale === 'en' 
                                    ? props.item.titleEn
                                    : $store.state.locale === 'zn'
                                      ? props.item.titleZh
                                      : props.item.title
                                }}</td> -->
                                  <td class="text-xs-center"
                                    v-if="props.item.department !== null"
                                  >{{ 
                                    $store.state.locale === 'en' 
                                      ? props.item.departmentEn 
                                      : $store.state.locale === 'zn'
                                        ? props.item.departmentEn
                                        : props.item.department | textLengthOverCut
                                  }}</td>
                                  
                                <td v-else-if="props.item.department === null" class="text-xs-center">
                                  -
                                </td>
                                <!-- <td class="text-xs-center">{{ props.item.email}}</td> -->
                                <td class="text-xs-center">
                                  <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                                    <v-icon color="error">clear</v-icon>
                                  </v-btn>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-card>


                    <!-- <v-widget 
                      :title="$t('page.meeting-reserve.organization.attendee-list')"
                      toolbar-bg="tertiary" 
                      toolbar-icon="people"
                      contentStyle="padding-top: 3px;">
                      <v-layout slot="widget-content" row wrap style="overflow: auto; height: 487px;">
                        <v-flex xs12>
                          <v-data-table slot="widget-content"
                            :headers="getAttendeeheaders()"
                            :items="selectedAttendees"
                            :rows-per-page-items="pageItem"
                            class="elevation-0 table-striped"
                            >
                            <template slot="items" slot-scope="props">
                              <td class="text-xs-center">{{ 
                                $store.state.locale === 'en' 
                                  ? props.item.nameEn ? props.item.nameEn : props.item.username ? props.item.username : props.item.email 
                                  : $store.state.locale === 'zn'
                                    ? props.item.nameZh ? props.item.nameZh : props.item.username ? props.item.username : props.item.email 
                                    : props.item.name ? props.item.name : props.item.username ? props.item.username : props.item.email 
                              }}</td>
                              <td class="text-xs-center">{{ 
                                $store.state.locale === 'en' 
                                  ? props.item.titleEn
                                  : $store.state.locale === 'zn'
                                    ? props.item.titleZh
                                    : props.item.title
                              }}</td>
                              <td class="text-xs-center">{{
                                $store.state.locale === 'en' 
                                  ? props.item.departmentEn 
                                  : $store.state.locale === 'zn'
                                    ? props.item.departmentEn
                                    : props.item.department
                              }}</td>
                              <td class="text-xs-center">
                                <v-icon color="error" @click="deleteItem(props.item)">clear</v-icon>
                              </td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-widget> -->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding-top:0px; padding-bottom:10px;">
          <v-spacer></v-spacer>
          <div class="popup-save-btn" @click="save">
            {{ $t('page.meeting-reserve.organization.save') }}
          </div>
          <div class="popup-close-btn" @click="close">
            {{ $t('page.meeting-reserve.organization.close') }}
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="twoSelectedDialog" persistent max-width="290">
      <v-card>
        <v-card-text>{{ $t('page.meeting-reserve.meeting-room-popup.only-one-select-msg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="cancel">{{ $t('page.meeting-reserve.meeting-room-popup.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading-dialog 
      :dialog="loadingDialog.dialog" 
      :content="loadingDialog.content"/>
  </v-layout>
</template>
<script>
import VWidget from '@/components/VWidget';
import LoadingDialog from '@/components/popup/LoadingDialog';
import debounce from 'lodash.debounce';
import moment from 'moment';
import Util from '@/util';

export default {
  filters: {
    textLengthOverCut (txt, len, lastTxt) { /* 글자 수 20이상 ...으로 표시 */
      if (txt !== null) {
        if (len === '' || len === null || typeof len === 'undefined') { 
          len = 20;
        }
        if (lastTxt === '' || lastTxt === null || typeof lastTxt === 'undefined') {
          lastTxt = '...';
        }
        if (txt.length > len) {
          txt = txt.substr(0, len) + lastTxt;
        }
      }
      return txt;
    }
  },
  components: {
    VWidget,
    LoadingDialog
  },
  props: [
    'meetingInfo',
    'roomItems',
    'personalItems',
    'people',
    'dialog',
    'closeDialog',
    'roomSave',
  ],
  data () {
    return {
      loadingDialog: {
        dialog: false,
        content: ''
      },
      loading: true,
      twoSelectedDialog: false,
      selectedType: 'room',
      caseSensitive: false,
      roomTree: [],
      filteredRoomItems: [],
      selectedRoom: {
        name: '',
        buildingName: '',
        capacity: '',
        floor: '',
        type: '',
        status: ''
      },
      defaultSelectedRoom: {
        name: '',
        buildingName: '',
        capacity: '',
        floor: '',
        type: '',
        status: ''
      },
      selected: [],
      selectedPersonal: [],
      selectedVideoRoom: [],
      roomActive: [],
      roomSearch: null,
      roomOpen: [],
      openAll: false,
      preRoomOpenData: [],
      personalSearch: null,
      search: '',
      searchRoomData: null,
      attendeeTree: [],
      deptUsers: [],
      organizationItems: [],
      selectedAttendees: [],
      selectedTreeNode: undefined,
      active: [],
      open: [1],
      pageItem: [-1], // [7],
      pagination: {
        sortBy: 'name'
      },
      isInitPersonalTree: false,
    };
  },
  computed: {
    filter () {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
    computePageHeaderIcon () {
      return '/static/page_header.png';
    }
  },
  watch: {
    dialog: {
      handler (val) {
        // true값일 경우
        if (val) {
          this.initData();
          if (this.meetingInfo.type === 0) {
            // 일반 회의인 경우 
            if (!Array.isArray(this.meetingInfo.roomIds)) {
              if (this.meetingInfo.roomIds !== undefined) {
                let node = Util.getNodeByValue('_id', this.meetingInfo.roomIds._id, this.roomItems);
                if (node !== null) {
                  this.selectedVideoRoom.push(node);
                }
              }
            }
          } else {
            this.meetingInfo.roomIds.forEach((roomDevice) => {
              let node = Util.getNodeByValue('_id', roomDevice._id, this.roomItems);
              if (node !== null) {
                this.selectedVideoRoom.push(node);
              }
            });
          }
          // if (this.meetingInfo.type === 0) {
          //   // 일반 회의인 경우 
          //   if (!Array.isArray(this.meetingInfo.roomIds)) {
          //     if (this.meetingInfo.roomIds !== undefined) {
          //       let node = Util.getNodeByValue('_id', this.meetingInfo.roomIds._id, this.roomItems);
          //       if (node !== null) {
          //         this.roomTree.push(node);
          //       }
          //     }
          //   }
          // } else {
          //   this.meetingInfo.roomIds.forEach((roomDevice) => {
          //     if (roomDevice.type === 'room') {
          //       let node = Util.getNodeByValue('_id', roomDevice.roomId, this.roomItems);
          //       if (node !== null) {
          //         this.roomTree.push(node);
          //       }
          //     } else {
          //       let node = Util.getNodeByValue('_id', roomDevice._id, this.personalItems);
          //       if (node !== null) {
          //         this.selected.push(node);
          //       }
          //     }
          //   });
          // }
        }
      }
    },
    // search (val) {
    //   let search = val;
    //   this.searchUser(search);
    // },
    // 'roomSearch': {
    //   handler (val) {
    //     let search = val;
    //     this.searchRoom(search);
    //   }
    // },
  },
  async mounted () {
    this.loading = false;
    // const myCompanyInfo = await this.getMyCompanyInfo();
    // await this.getOrganizationTree(undefined, true);
  },
  methods: {
    async fetchUsers (item) {
      console.log(`fetchUsers`, item);
      await this.getOrganizationTree(item, false);
    },
    initData () {
      this.roomActive = [];
      this.roomOpen = [];
      this.preRoomOpenData = [];
      this.selectedVideoRoom = [];
      this.selected = [];
      this.selectedPersonal = [];
      this.attendeeTree = [];
      this.selectedAttendees = [];
      this.roomTree = [];
      this.selectedRoom = Object.assign({}, this.defaultSelectedRoom);
      this.selectedType = 'room';
      this.filteredRoomItems = Object.assign([], this.roomItems);
      console.log(`this.filteredRoomItems`, this.filteredRoomItems);
    },
    async selectedTypeChanged (type) {
      this.selectedType = type;
      // personal이고, isInitPersonalTree 이면 getOrganizationTree 한다.
      if (this.selectedType === 'personal') {
        this.loadingDialog.dialog = true;
        await this.getOrganizationTree(undefined, true);
        this.loadingDialog.dialog = false;
      }
    },
    async getMyCompanyInfo () {
      return new Promise((resolve, reject) => {
        this.$http.get(`/api/v1/organizations`, { 
          params: { 
            emails: [this.$store.state.user.email]
          }
        }).then(response => {
          let myCompanyInfo = response.data;
          if (myCompanyInfo.length > 0) {
            resolve(myCompanyInfo[0]);
          } else {
            resolve(undefined);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
    async getOrganizationTree (selectedItem, isInit) {
      this.search = '';
      let params = {
        isInit: isInit
      };
      if (isInit) {
        this.organizationItems = [];
        this.open = [1];
      }
      if (selectedItem !== undefined) {
        params['orgUnitId'] = selectedItem.orgUnitId;
      } else {
        let email = this.$store.state.user.email;
        let userCompanyInfo = (await this.$http.get('/api/v1/organizations', { params: { emails: [email] }})).data;
        if (userCompanyInfo.length > 0) {
          params['orgUnitId'] = userCompanyInfo.orgUnitId;
        }
      }
      let myCompanyInfo = await this.getMyCompanyInfo();
      if (myCompanyInfo) {
        params['rootOrgUnitId'] = myCompanyInfo.rootOrgUnitId !== null && myCompanyInfo.rootOrgUnitId !== undefined 
          ? myCompanyInfo.rootOrgUnitId : -1;
      } else {
        params['rootOrgUnitId'] = -1;
      }
      await this.$http.get('/api/v1/organizations/trees/dynamic', { params: params }).then(response => {
        // Dynamic Version
        if (isInit) {
          this.organizationItems = response.data;
        } else {
          selectedItem.children.push(...response.data);
        }

        // 다가져와서 하는 버전
        // this.myCompanyOrgData = response.data;
        // let startLevel = response.data.reduce((prev, curr) => {
        //   return prev.level < curr.level ? prev : curr;
        // });
        // let endLevel = response.data.reduce((prev, curr) => {
        //   return prev.level > curr.level ? prev : curr;
        // });
        // this.organizationItems = this.makeTreeData(response.data, startLevel.level, endLevel.level, myCompanyInfo.orgUnitId);
        this.openOrganizationFolder(myCompanyInfo.rootOrgUnitId, myCompanyInfo.orgUnitId);
      }).catch(error => {
        console.log(error);
      });
    },
    async selectedNode (selectedItem) {
      this.selectedTreeNode = selectedItem;
      this.search = '';
      const deptUnitId = selectedItem.orgUnitId;
      const deptUsers = (await this.$http.get(`/api/v1/users/dept/${deptUnitId}`)).data;
      this.deptUsers = deptUsers;
    },
    makeTreeData (data, start, end, orgUnitId) {
      let items = [];
      for (let i = start; i <= end + 1; i++) {
        if (i === start) {
          let index = data.findIndex(x => x.level === i);
          let rootNode = data[index];
          items.push(rootNode);
          // this.open.push(root[0]._id);
        } else {
          let rootNodes = data.filter(x => x.level === i - 1);
          rootNodes.forEach(item => {
            let childItems = data.filter(x => x.upperOrgUnitId === item.orgUnitId);
            if (childItems.length > 0) {
              item.children.push(...childItems);
            } else {
              item.type = 'l';
              delete item.children;
            }
          });
        }
      }
      return items;
    },
    openOrganizationFolder (rootOrgUnitId, orgUnitId) {
      let isMyOrgFlag = true;
      let findId = orgUnitId;
      while (rootOrgUnitId !== findId) {
        let getIndex = function (myCompanyOrgData, findId) {
          return myCompanyOrgData.findIndex(x => x.orgUnitId === findId);
        };
        let findIndex = getIndex(this.myCompanyOrgData, findId);
        if (isMyOrgFlag) {
          this.active.push(this.myCompanyOrgData[findIndex]);
          this.selectedNode(this.myCompanyOrgData[findIndex]);
          isMyOrgFlag = false;
        }
        if (findIndex > 0) {
          findId = this.myCompanyOrgData[findIndex].upperOrgUnitId;
          this.open.push(this.myCompanyOrgData[findIndex]);
        } else {
          break;
        }
      }
      let findIndex = this.myCompanyOrgData.findIndex(x => x.orgUnitId === rootOrgUnitId);
      this.open.push(this.myCompanyOrgData[findIndex]);
    },
    getStatusColor (status) {
      if (status === 'a') {
        return 'green';
      } else if (status === 'd') {
        return 'red';
      } else {
        return 'primary';
      }
    },
    getMeetingRoomsHeaders () {
      if (this.meetingInfo.type === 0) {
        return [
          { text: this.$t('page.meeting-reserve.meeting-room-popup.name'), align: 'center', value: 'name', sortable: false, class: 'header-text' },
          { text: this.$t('page.meeting-reserve.meeting-room-popup.capacity'), align: 'center', width: '40px', value: 'capacity', sortable: false, class: 'header-text' },
          { text: this.$t('page.meeting-reserve.meeting-room-popup.delete'), align: 'center', width: '40px', sortable: false, class: 'header-text' },
        ];
      } else {
        return [
          { text: this.$t('page.meeting-reserve.meeting-room-popup.name'), align: 'center', value: 'nameIP', sortable: false, class: 'header-text' },
          { text: this.$t('page.meeting-reserve.meeting-room-popup.ip'), align: 'center', value: 'ip', sortable: false, class: 'header-text' },
          // { text: this.$t('page.meeting-reserve.meeting-room-popup.capacity'), align: 'center', width: '40px', value: 'capacity', sortable: true },
          { text: this.$t('page.meeting-reserve.meeting-room-popup.status'), align: 'center', width: '70px', value: 'status', sortable: false, class: 'header-text' },
          { text: this.$t('page.meeting-reserve.meeting-room-popup.delete'), align: 'center', width: '50px', sortable: false, class: 'header-text' },
        ];
      }
    },
    getPersonalHeaders () {
      return [
        { text: this.$t('page.meeting-reserve.meeting-room-popup.name'), value: 'displayName', align: 'center', class: 'header-text' },
        { text: this.$t('page.meeting-reserve.meeting-room-popup.department'), value: 'department', align: 'center', class: 'header-text' },
      ];
    },
    getAttendeeheaders () {
      return [
        { text: this.$t('page.meeting-reserve.organization.name'), align: 'center', width: 80, value: 'name', sortable: false, class: 'header-text' },
        { text: this.$t('page.meeting-reserve.organization.position'), align: 'center', width: 80, value: 'title', sortable: false, class: 'header-text' },
        { text: this.$t('page.meeting-reserve.organization.team'), align: 'center', value: 'department', sortable: false, class: 'header-text' },
        // { text: this.$t('page.meeting-reserve.organization.email'), align: 'center', value: 'email', sortable: true, class: 'header-text' },
        { text: this.$t('page.meeting-reserve.organization.delete'), align: 'center', width: 50, sortable: false, class: 'header-text' },
      ];
    },
    getPeopleHeaders () {
      return [
        { text: this.$t('page.meeting-reserve.organization.name'), align: 'center', width: 80, value: 'username', sortable: false, class: 'header-text' },
        { text: this.$t('page.meeting-reserve.organization.position'), align: 'center', width: 80, value: 'department', sortable: false, class: 'header-text' },
        { text: this.$t('page.meeting-reserve.organization.team'), align: 'center', value: 'department', sortable: false, class: 'header-text' },
        // { text: this.$t('page.meeting-reserve.organization.position'), align: 'center', value: 'title', sortable: false },
      ];
    },
    toggleAll () {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.deptUsers.filter((elem) => elem.name.includes(this.search) || elem.department.includes(this.search)).slice();
      }
    },
    setAttendees () {
      this.selected.forEach((attendee) => {
        if (this.selectedAttendees.filter(item => item.email === attendee.email).length === 0) {
          this.selectedAttendees.push(attendee);
        }
      });
      
      // this.attendeeTree = [];
      this.selected = [];
    },
    // setAttendees () {
    //   if (this.search === '') {
    //     this.attendeeTree.forEach((attendee) => {
    //       if (attendee.type !== 'd') {
    //         if (this.selectedAttendees.filter(item => item.email === attendee.email).length === 0) {
    //           this.selectedAttendees.push(attendee);
    //         }
    //       }
    //     });
    //   } else {
    //     this.selected.forEach((attendee) => {
    //       if (this.selectedAttendees.filter(item => item.email === attendee.email).length === 0) {
    //         this.selectedAttendees.push(attendee);
    //       }
    //     });
    //   }
      
    //   this.attendeeTree = [];
    //   this.selected = [];
    // },
    deleteRoomItem (item) {
      // this.roomTree = [];
      let index = this.selectedVideoRoom.findIndex(elem => elem._id === item._id);
      this.selectedVideoRoom.splice(index, 1);
    },
    deleteItem (item) {
      this.attendeeTree = [];
      let index = this.selectedAttendees.findIndex(elem => elem._id === item._id);

      this.selectedAttendees.splice(index, 1);
    },
    save () {
      this.roomSave(this.selectedVideoRoom, this.selectedAttendees);
      this.initData();
    },
    close () {
      this.closeDialog();
    },
    cancel () {
      // this.roomTree = [];
      this.selectedVideoRoom.splice(1, this.selectedVideoRoom.length);
      // this.selectedVideoRoom.forEach((room) => {
      //   let node = Util.getNodeByValue('_id', room._id, this.roomItems);
      //   if (node !== null) {
      //     this.roomTree.push(node);
      //   }
      // });
      this.twoSelectedDialog = false;
      // let index = this.selectedVideoRoom.findIndex(elem => elem._id === item._id);

    },
    clickDevice (props) {
      if (!props.item.isReserved) {
        props.selected = !props.selected;
      }
    },
    addItems () {
      console.log(`this.roomTree11`, this.roomTree);
      if (this.selectedType === 'room') {
        if (this.meetingInfo.type === 0) {
          let isSelectedRoomsForFindRegacyRoom = this.selectedVideoRoom.findIndex(room => room._id === this.meetingInfo.roomIds);
          if (isSelectedRoomsForFindRegacyRoom > -1) {
            this.selectedVideoRoom.splice(isSelectedRoomsForFindRegacyRoom, 1);
          } else {
            this.selectedVideoRoom.splice(0, 1);
          }
        }
        console.log(`this.roomTree`, this.roomTree);
        let filterOnlyRooms = this.roomTree.filter(item => item.children === undefined);
        console.log(`filterOnlyRooms`, filterOnlyRooms);
        filterOnlyRooms.forEach((room) => {
          if (this.selectedVideoRoom.filter(item => item._id === room._id).length === 0) {
            this.selectedVideoRoom.push(room);
          }
        });
        if (this.selectedVideoRoom.length > 1 && this.meetingInfo.type === 0) {
          this.twoSelectedDialog = true;
          this.roomTree = [];
        } else {
          this.roomTree = [];
        }
      } else if (this.selectedType === 'personal') {
        this.selected.forEach((device) => {
          if (this.selectedPersonal.filter(item => item.email === device.email).length === 0) {
            this.selectedPersonal.push(device);
          }
        });
        this.selected = [];
      }

      // if (this.selectedType === 'room') {
      //   let filterOnlyRooms = this.roomTree.filter(item => item.children === undefined);
      //   filterOnlyRooms.forEach((room) => {
      //     if (this.selectedVideoRoom.filter(item => item._id === room._id).length === 0) {
      //       this.selectedVideoRoom.push(room);
      //     }
      //   });
      //   if (this.selectedVideoRoom.length > 1 && this.meetingInfo.type === 0) {
      //     this.twoSelectedDialog = true;
      //   } else {
      //     this.roomTree = [];
      //   }
      // } else if (this.selectedType === 'personal') {
      //   this.selected.forEach((device) => {
      //     if (this.selectedPersonal.filter(item => item.email === device.email).length === 0) {
      //       this.selectedPersonal.push(device);
      //     }
      //   });
      //   this.selected = [];
      // }
    },
    deleteAll () {
      if (this.selectedType === 'room') {
        this.selectedVideoRoom = [];
      } else if (this.selectedType === 'personal') {
        this.selectedAttendees = [];
      }
    },
    selectedRoomNode (item) {
      this.roomTree = item;      
    },
    clickPeople (props) {
      if (!props.item.isReserved) {
        props.selected = !props.selected;
      }
    },
    searchUser: debounce(async function (text) {
      let searchLength = 4;
      const check = /[ㄱ-ㅎ]|[ㅏ-ㅣ]|[가-힣]/;
      if (check.test(text)) {
        searchLength = 2;
      }
      if (text === null || text === '' || text.length < searchLength) {
        this.treeItems = this.totalItems;
        return;
      }
      this.getPeople(text.trim());
    }, 300),
    async getPeople (text) {
      await this.$http.get('/api/v1/organizations/filtered', { params: { search: text, limit: 100 }}).then(response => {
        this.deptUsers = response.data.splice(0, 100);
      }).catch(error => {
        console.log(error);
      });
    },
    searchRoom: debounce(async function (text) {
      let searchLength = 4;
      const check = /[ㄱ-ㅎ]|[ㅏ-ㅣ]|[가-힣]/;
      if (check.test(text)) {
        searchLength = 2;
      }
      if (text === null || text === '' || text.length < searchLength) {
        this.roomOpen = JSON.parse(JSON.stringify(this.preRoomOpenData));
        return;
      }
      await this.getRoomTree(text);
    }, 200),
    async getRoomTree (text) {
      this.preRoomOpenData = JSON.parse(JSON.stringify(this.roomOpen));
      let params = {
        type: 'video'
      };
      if (text !== undefined) {
        params['search'] = text;
      }
      await this.$http.get('/api/v1/rooms/getRoomTreeAll', { params: params }).then(response => {
        const searchData = response.data;
        // open All Tree
        if (text !== undefined) {
          searchData.forEach(item => {
            this.roomOpen.push(item);
            if (item.children.length > 0) {
              item.children.forEach(building => {
                this.roomOpen.push(building);
              });
            }
          });
        }
      }).catch(error => {
        console.log(error);
      });
    },
    async searchRooms (text) {
      console.log(`searchRooms`, text);
      if (text === '' || !text) {
        this.filteredRoomItems = Object.assign([], this.roomItems);
      } else {
        // Get Search Rooms
        // console.log(`text`, text);
        let start = moment.tz(this.meetingInfo.reservedDate + ' ' + this.meetingInfo.startTime, this.meetingInfo.timeZone);
        let end = moment.tz(this.meetingInfo.reservedEndDate + ' ' + this.meetingInfo.endTime, this.meetingInfo.timeZone);
        let now = moment.tz(moment().format('YYYY-MM-DD HH:mm'), this.meetingInfo.timeZone);
        let meetingType = this.meetingInfo.type === 0 ? 'room' : 'video';

        if (this.meetingInfo.type === 2) {
          start = now.utc().format();
        } else {
          start = start.utc().format();
        }
        end = end.utc().format();
        
        let params = { meetingType: meetingType, start: start, end: end };
        if (this.editMode) {
          params['_id'] = this.routerParams._id;
        }

        if (this.meetingInfo.type === 0) {
          params['type'] = 'room';
          // My Company Room Only
          params['company'] = this.$store.state.user.company ? this.$store.state.user.company : undefined;
        } else {
          params['type'] = 'video';
        }

        params['email'] = this.$store.state.user.email;
        params['search'] = text;
        await this.$http.get('/api/v1/rooms/getRoomTreeAll', { params: params }).then(response => {
          // const searchData = response.data;
          this.filteredRoomItems = response.data;
          // open All Tree
          if (text !== undefined) {
            this.filteredRoomItems.forEach(item => {
              this.roomOpen.push(item);
              if (item.children.length > 0) {
                item.children.forEach(building => {
                  this.roomOpen.push(building);
                });
              }
            });
          }
        }).catch(error => {
          console.log(error);
        });
      }
    },
    searchEnterKey: function (e) {
      if (e.keyCode === 13) {
        if (this.selectedType === 'room') {
          this.searchRooms(this.searchRoomData);
        } else {
          this.searchUser(this.search);
        }
      }
    },
    treeViewDoubleClick (props) {
      if (!props.children) {
        let index = this.selectedVideoRoom.findIndex(room => room._id === props._id);
        if (index < 0) {
          this.selectedVideoRoom.push(props);
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.room-meeting {
  margin-top: -55px;
}

.room-state-btn{
  width: 50px;
  height: 25px;
  border-radius: 7px;
  font-weight: 300;
  font-size: 13px;
  text-align: center;
  line-height: 25px;
  background: rgb(0, 120, 212);
  cursor: pointer;
  color: white;
  display:inline-block;
}

.room-state-btn2{
  width: 50px;
  height: 25px;
  border-radius: 7px;
  font-weight: 300;
  font-size: 13px;
  text-align: center;
  line-height: 25px;
  background: #c4314b;
  cursor: pointer;
  color: white;
  display:inline-block;
}

.meeting-additional .v-table__overflow{
  max-height: 280px;
  overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/MeetingAdditionalInviteDialog.vue